import { render, staticRenderFns } from "./detailsOfAssess.vue?vue&type=template&id=fd787c5a&scoped=true&"
import script from "./detailsOfAssess.vue?vue&type=script&lang=js&"
export * from "./detailsOfAssess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd787c5a",
  null
  
)

export default component.exports